module.exports = __webpack_public_path__ + "img/default_thumbnail.6f743ead.jpg";